<div class="row" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <div *ngFor="let data of mappedData" class="col-6 col-md-4 col-lg-2 mb-2">
    <div class="card product-card">
      <div class="card-body">
        <div class="image-wrapper">
          <img
            class="img-fluid"
            src="https://cdn1.gung.io/fit-in/250x250/filters:etag({{
              data.product.extra.images[0].s3ETag
            }})/{{ data.product.extra.images[0].s3Uri }}"
            alt=""
          />
        </div>
        <div class="product-text pb-1">
          <div class="text-truncate text-primary" translate>{{ data.product.name }}</div>
          <div
            translate
            *ngIf="data.price"
            class="font-weight-bold text-primary text-uppercase"
            [class.d-none]="hidePrice"
          >
            {{ data.price.customerNetPrice.value | gungCurrency: data.price.customerNetPrice.currencyCode }}
          </div>
        </div>
        <button
          class="btn btn-block btn-sm btn-show-product text-uppercase"
          [routerLink]="['/product/', data.product.id]"
          translate
        >
          SHOW_PRODUCT
        </button>
      </div>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <button class="btn btn-sm btn-utforska text-uppercase" [routerLink]="['/categories/sNEWPRODUCT/']" translate>
    EXPLORE_THE_RANGE
  </button>
</div>

<!-- <div class="col-12 col-md-8 colmec-login-reset-password-bg-img d-flex justify-content-center ">
  <div class="d-flex align-items-center">
  </div>
</div> -->
